import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const SoftwareDevelopmentPage = lazy(() => import('../pages/software-development/page'));
const CloudInfrastructurePage = lazy(() => import('../pages/cloud-infrastructure/page'));
const ITSupportPage = lazy(() => import('../pages/it-support/page'));
const IndustriesPage = lazy(() => import('../pages/industries/page'));
const CaseStudiesPage = lazy(() => import('../pages/case-studies/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Case Study Detail Pages
const BankingCaseStudyPage = lazy(() => import('../pages/case-studies/core-banking-modernization/page'));
const HealthcareCaseStudyPage = lazy(() => import('../pages/case-studies/healthcare-digital-transformation/page'));
const RetailCaseStudyPage = lazy(() => import('../pages/case-studies/retail-ecommerce-platform/page'));
const ManufacturingCaseStudyPage = lazy(() => import('../pages/case-studies/manufacturing-iot-solution/page'));
const LogisticsCaseStudyPage = lazy(() => import('../pages/case-studies/logistics-supply-chain/page'));
const EducationCaseStudyPage = lazy(() => import('../pages/case-studies/education-learning-platform/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/software-development',
    element: <SoftwareDevelopmentPage />,
  },
  {
    path: '/cloud-infrastructure',
    element: <CloudInfrastructurePage />,
  },
  {
    path: '/it-support',
    element: <ITSupportPage />,
  },
  {
    path: '/industries',
    element: <IndustriesPage />,
  },
  {
    path: '/case-studies',
    element: <CaseStudiesPage />,
  },
  {
    path: '/case-studies/core-banking-modernization',
    element: <BankingCaseStudyPage />,
  },
  {
    path: '/case-studies/healthcare-digital-transformation',
    element: <HealthcareCaseStudyPage />,
  },
  {
    path: '/case-studies/retail-ecommerce-platform',
    element: <RetailCaseStudyPage />,
  },
  {
    path: '/case-studies/manufacturing-iot-solution',
    element: <ManufacturingCaseStudyPage />,
  },
  {
    path: '/case-studies/logistics-supply-chain',
    element: <LogisticsCaseStudyPage />,
  },
  {
    path: '/case-studies/education-learning-platform',
    element: <EducationCaseStudyPage />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
